import { filter } from "../../../../utils/search";
import lodash from "lodash";

export const createFilterTreeNode = ({ props }) => {
    return (value, treeNode) => {
        const where = props.filterWhere ? props.filterWhere({ value, treeNode }) : [{ name: props.optLabel, operator: "like", value }];
        return filter({ list: [treeNode.props.dataRef.item], where, sort: [] }).length > 0;
    };
};

export const createReloadItems = ({ data, props }) => {
    return () => {
        data.isLoading = true;
        const result = props.list();
        if (result instanceof Promise) {
            result.then(items => {
                data.items = items;
                data.isLoading = false;
            });
        } else {
            data.items = result;
            data.isLoading = false;
        }
    };
};

export const createOnUpdateValue = ({ data, props, emit }) => {
    return value => {
        data.searchQuery = "";
        if (value) {
            value = findItem({ value, items: data.items, props });
        }
        emit("update:value", lodash.cloneDeep(value));
    };
};

export const findItem = ({ value, items, props }) => {
    let result = null;
    items.forEach(item => {
        if (value === lodash.get(item, props.optKey)) {
            result = item;
            return;
        }
        const child = findItem({ value, items: lodash.get(item, props.optChildren) || [], props });
        if (child) {
            result = child;
            return;
        }
    });
    return result;
};

export const itemsToTrees = ({ items, data, props }) => {
    return items.map(item => itemToTree({ item, data, props }));
};

export const itemToTree = ({ item, data, props }) => {
    const children = lodash.get(item, props.optChildren);
    return {
        key: lodash.get(item, props.optKey),
        value: lodash.get(item, props.optKey),
        disabled: props.optEnabled ? !lodash.get(item, props.optEnabled) : false,
        title: props.renderLabel ? undefined : lodash.get(item, props.optLabel),
        children: children ? itemsToTrees({ items: children, data, props }) : null,
        slots: { title: props.renderLabel ? "title" : undefined },
        item
    };
};
